module.exports = __webpack_public_path__ + "fonts/intelo-bold.b6ff49f.woff2";